/**
 * WowStore POD Cart Integration
 * Handles add-to-cart for print-on-demand products via the Product Configurator.
 * Listens for 'pod:add-to-cart' events and uses Shopify AJAX Cart API.
 */
(function() {
  'use strict';

  var POD_API = 'https://ai-api.wowstore.live';

  // Cache for POD product variant IDs (fetched once per session)
  var variantCache = {};

  /**
   * Find or create a Shopify variant ID for a POD product type.
   * Uses products tagged 'pod-ready' + matching product type.
   */
  async function findVariantId(productType, size, color) {
    var cacheKey = productType + ':' + (size || '') + ':' + (color || '');
    if (variantCache[cacheKey]) return variantCache[cacheKey];

    try {
      // Search Shopify for POD products matching this type
      var resp = await fetch('/search/suggest.json?q=pod-ready+' + encodeURIComponent(productType) + '&resources[type]=product&resources[limit]=5');
      var data = await resp.json();
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];

      if (products.length > 0) {
        // Get full product data to find matching variant
        var productResp = await fetch('/products/' + products[0].handle + '.js');
        var product = await productResp.json();

        // Find variant matching size/color
        var variant = null;
        if (product.variants && product.variants.length > 0) {
          variant = product.variants.find(function(v) {
            var matchSize = !size || v.option1 === size || v.option2 === size;
            var matchColor = !color || v.option1 === color || v.option2 === color;
            return matchSize && matchColor && v.available;
          });
          if (!variant) variant = product.variants[0]; // Fallback to first variant
        }

        if (variant) {
          variantCache[cacheKey] = variant.id;
          return variant.id;
        }
      }
    } catch(e) {
      console.warn('[POD Cart] Could not find variant for', productType, e);
    }

    return null;
  }

  /**
   * Add a POD item to Shopify cart with line_item properties.
   */
  async function addToCart(detail) {
    var properties = detail.properties || {};
    var productType = detail.product_type;

    // Find the variant ID
    var variantId = await findVariantId(productType, properties.Size, properties.Color);

    if (!variantId) {
      console.warn('[POD Cart] No variant found, redirecting to Design Library');
      showNotification('Product is being prepared. Please try again shortly.', 'info');
      return;
    }

    try {
      var resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1,
            properties: properties
          }]
        })
      });

      if (resp.ok) {
        var cartData = await resp.json();
        showNotification('Added to cart!', 'success');
        updateCartCount();

        // Track analytics
        if (window.LucyAnalytics) {
          window.LucyAnalytics.track('pod_cart_add_success', {
            product_type: productType,
            variant_id: variantId,
            provider: properties._pod_provider
          });
        }
      } else {
        var err = await resp.json();
        console.error('[POD Cart] Add to cart failed:', err);
        showNotification('Could not add to cart. Please try again.', 'error');
      }
    } catch(e) {
      console.error('[POD Cart] Cart error:', e);
      showNotification('Something went wrong. Please try again.', 'error');
    }
  }

  /**
   * Update cart count in header.
   */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var countEls = document.querySelectorAll('.cart-count, .cart-count-bubble, [data-cart-count]');
        countEls.forEach(function(el) { el.textContent = cart.item_count; });

        // Dispatch event for theme JS to pick up
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: cart.item_count, total: cart.total_price } }));
      })
      .catch(function() {});
  }

  /**
   * Show a brief notification toast.
   */
  function showNotification(message, type) {
    var existing = document.getElementById('podNotification');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.id = 'podNotification';
    toast.textContent = message;
    toast.style.cssText = 'position:fixed;bottom:20px;left:50%;transform:translateX(-50%);padding:12px 24px;border-radius:8px;font-size:14px;font-weight:600;z-index:99999;transition:opacity 0.3s;';

    if (type === 'success') {
      toast.style.background = '#16a34a';
      toast.style.color = '#fff';
    } else if (type === 'error') {
      toast.style.background = '#dc2626';
      toast.style.color = '#fff';
    } else {
      toast.style.background = '#000';
      toast.style.color = '#fff';
    }

    document.body.appendChild(toast);
    setTimeout(function() {
      toast.style.opacity = '0';
      setTimeout(function() { toast.remove(); }, 300);
    }, 3000);
  }

  // Listen for pod:add-to-cart events from the Product Configurator
  document.addEventListener('pod:add-to-cart', function(e) {
    addToCart(e.detail);
  });

  // Expose for direct use
  window.PodCart = { addToCart: addToCart, findVariantId: findVariantId };
})();
